import clsx from 'clsx'

interface StarRatingProps {
  rating: number
  className?: string
}

function StarIcon({ filled, className }: { filled: boolean; className?: string }) {
  return (
    <svg
      viewBox="0 0 200 200"
      aria-hidden="true"
      className={clsx('h-5 w-5', className)}
    >
      <path
        fill={filled ? '#FBBC05' : '#E0E0E0'}
        d="M187.183 57.47a9.955 9.955 0 0 0-8.09-6.846l-52.05-7.52-23.306-46.94a10.035 10.035 0 0 0-8.008-5.456c-3.4-.27-6.696 1.186-8.766 3.876a9.658 9.658 0 0 0-1.05 1.58L62.616 43.114l-52.05 7.52a9.955 9.955 0 0 0-8.09 6.846 9.86 9.86 0 0 0 2.52 10.18l37.636 36.47-8.886 51.5a9.908 9.908 0 0 0 4.006 9.746 10.074 10.074 0 0 0 10.616.73L95.01 143.02l46.66 24.396a10.138 10.138 0 0 0 4.656 1.146 9.97 9.97 0 0 0 5.95-1.956 9.908 9.908 0 0 0 4.006-9.746l-8.876-51.51 37.626-36.46a9.87 9.87 0 0 0 2.52-10.19l-.37-.23z"
      />
    </svg>
  )
}

export function StarRating({ rating, className }: StarRatingProps) {
  return (
    <div className={clsx('flex', className)}>
      {[...Array(5).keys()].map((index) => (
        <StarIcon key={index} filled={rating > index} />
      ))}
    </div>
  )
}
